export default "__VITE_ASSET__Br16tOR___ 100w";